<template>
  <v-dialog v-model="licensesCompanyDialog" persistent max-width="700px">
    <v-card>
      <v-card-title>
        <span class="headline">Licenses</span>
      </v-card-title>
      <v-container>
      	<v-data-table :headers="headers" :items="companyLicenses" :loading="loading" loading-text="Loading Licenses..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true, firstIcon: 'first_page', lastIcon: 'last_page', prevIcon: 'navigate_before', nextIcon: 'navigate_next'}" class="elevation-1">       
          <template v-slot:item.actions="{ item }">
						<v-icon small @click.prevent="openEditLicenseDialog(item)">edit</v-icon>
						<v-icon small @click.prevent="openDeleteLicenseDialog(item)">delete</v-icon>
					</template>
		    </v-data-table>		
        <v-dialog v-model="deleteLicenseDialog" persistent max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">Delete License</span>
						</v-card-title>
						<v-card-text>
              <v-progress-linear :active="isLoadingDialog" height="3" indeterminate absolute color="primary" />
							<v-container>
                <v-row >
                  <v-alert dense outlined :value="alert.isAlert" color="error" >{{ alert.alertMessage }}</v-alert>
                </v-row>
								<v-row>
									<v-col cols="12">
										<span>The license will be permanently removed!</span>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click.prevent="closeDeleteLicenseDialog()">Close</v-btn>
							<v-btn color="primary" @click.prevent="deleteLicense()">Delete</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>    			
        <v-dialog v-model="editLicenseDialog" persistent max-width="500px">
				<v-card>
					<v-card-title>
						<span class="headline">Edit License</span>
					</v-card-title>
					<v-card-text>
            <v-progress-linear :active="isLoadingDialog" height="3" indeterminate absolute color="primary" />
						<v-container>
							<v-form ref="editCompanyLicensesForm">
                <v-row >
                  <v-alert dense outlined :value="alert.isAlert" color="error" >{{ alert.alertMessage }}</v-alert>
                </v-row>
								<v-row>
                  <v-col cols="12">
                    <v-select v-model="license.license_id" :items="licenses" item-text="name" item-value="id" label="License Name" autocomplete="off" dense disabled />
                  </v-col>
                  <v-row>
                    <v-col cols="6">
                      <v-menu v-model="datePickerMenuEdit1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :rules="[...getRlDialogRules.required]" v-model="license.start_date" prepend-icon="event" readonly v-bind="attrs" v-on="on" label="Start Date" dense />
                        </template>
                        <v-date-picker v-model="license.start_date" @input="datePickerMenuEdit1 = false" />
                      </v-menu>
                    </v-col>
                    <v-col cols="6">
											<v-menu v-model="datePickerMenuEdit2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :rules="[...getRlDialogRules.required]" v-model="license.end_date" prepend-icon="event" readonly v-bind="attrs" v-on="on" label="Start Date" dense />
                        </template>
                        <v-date-picker v-model="license.end_date" @input="datePickerMenuEdit2 = false" />
                      </v-menu>                                                  
                    </v-col>
                  </v-row>
                </v-row>						
							</v-form>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary darken-1" text @click.prevent="closeEditLicenseDialog()">Close</v-btn>
						<v-btn color="primary" @click.prevent="updateLicense()">Save</v-btn>
					</v-card-actions>
				</v-card>		
				</v-dialog>	
        <v-dialog v-model="addLicenseDialog" persistent max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">Add License</span>
						</v-card-title>                     
						<v-card-text>
              <v-progress-linear :active="isLoadingDialog" height="3" indeterminate absolute color="primary" />
							<v-container>
								<v-form ref="addCompanyLicensesForm">
                  <v-row >
                    <v-alert dense outlined :value="alert.isAlert" color="error" >{{ alert.alertMessage }}</v-alert>
                  </v-row>
									<v-row>
                  	<v-col cols="12">
                      <v-select v-model="license" :items="licenses" item-text="name" item-value="id" return-object :rules="[...getRlDialogRules.required]" label="License Name" autocomplete="off" dense />
                    </v-col>
                  	<v-row>
											<v-col cols="6">
												<v-menu v-model="datePickerMenu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
													<template v-slot:activator="{ on, attrs }">
														<v-text-field :rules="[...getRlDialogRules.required]" v-model="licenseStartDate" prepend-icon="event" readonly v-bind="attrs" v-on="on" label="Start Date" dense />
													</template>
													<v-date-picker v-model="licenseStartDate" @input="datePickerMenu1 = false" />
												</v-menu>
											</v-col>
											<v-col cols="6">                                                        
												<template>
													<v-text-field disabled aria-readonly="true" :rules="[...getRlDialogRules.required]" :value="licenseEndDate" prepend-icon="event" readonly label="End Date" dense />
												</template>                                                                                             
											</v-col>
										</v-row>
									</v-row>						
								</v-form>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer />
							<v-btn color="primary darken-1" text @click.prevent="closeAddLicenseDialog()">Close</v-btn>
							<v-btn color="primary" @click.prevent="addLicense()">Save</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
      </v-container>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary darken-1" text @click.prevent="isCloseLicensesCompanyDialog()">Close</v-btn>
        <v-btn color="primary" @click.prevent="openAddLicenseDialog()" >Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'CompanyLicenses',    
  props: ['idCompany', 'licensesCompanyDialog'],
  data() {
    return {
			headers: [			
				{ text: 'Name', value: 'license_name' },	
				{ text: 'Valid From', value: 'start_date' },
				{ text: 'Valid To', value: 'end_date' },
				{ text: 'Actions', value: 'actions', sortable: false },			
			],
    	isLoadingDialog: false,
    	alert: {isAlert: false, alertMessage: ''},
			addLicenseDialog: false,
			editLicenseDialog: false,
			deleteLicenseDialog: false, 
			licenses: [],
    	companyLicenses: [],
			license: {},
			licenseStartDate: '',
			datePickerMenu1: false,
			datePickerMenuEdit1: false,
			datePickerMenuEdit2: false, 
			currentLicense: {},
			loading: true,            
      }
  },
	mounted() {
			this.getCompanyLicenses()
			this.getLicenses()
	},
	methods: {
		async getLicenses() {
			try {
				const response = await axios.get("api/v1/licenses")
				this.licenses = response.data.data
			} catch (error) {
				//
			}
		},
		async getCompanyLicenses() {
			try {                
				this.loading = true;
				const response = await axios.get("api/v1/companies/" + this.idCompany + "/licenses")
				this.companyLicenses = response.data.data
				this.loading = false               
			} catch (error) {
				this.loading = false              
			}
		},
		openAddLicenseDialog() {
			this.license = {}
			let startDate = new Date(this.companyLicenses[0]?.end_date)
			startDate.setDate(startDate.getDate() + 1)
			this.licenseStartDate = this.companyLicenses[0]?.end_date ? startDate.toISOString().slice(0, 10) : new Date().toISOString().substr(0, 10)  
			this.addLicenseDialog = true
		},
		closeAddLicenseDialog() {
			this.addLicenseDialog = false
			this.alert = {isAlert: false, alertMessage: ''} 
		},
		async addLicense() {        
			if (this.$refs.addCompanyLicensesForm.validate()) {
				try {     
					this.isLoadingDialog = true
					const license = { license_id: this.license.id, start_date: this.licenseStartDate,	end_date: this.licenseEndDate	}
					await axios.post("api/v1/companies/" + this.idCompany + "/licenses", JSON.stringify(license))
					this.addLicenseDialog = false
					await this.getCompanyLicenses()
					this.isLoadingDialog = false      
				} catch (error) {   
					this.isLoadingDialog = false                    
					this.alert = {isAlert: true, alertMessage: error.response.data.message}                      
				}                
			}
		},
		openEditLicenseDialog(item) {	        
			this.license = Object.assign({}, item)
			this.editLicenseDialog = true
		},    
		closeEditLicenseDialog() {
			this.editLicenseDialog = false   
			this.alert = {isAlert: false, alertMessage: ''}   
		},
		async updateLicense() {
			if (this.$refs.editCompanyLicensesForm.validate()) {
				try { 
					this.isLoadingDialog = true
					const license = {	license_id: this.license.license_id, start_date: this.license.start_date, end_date: this.license.end_date }                    
					await axios.put("api/v1/companies/" + this.idCompany + "/licenses/" + this.license.id, JSON.stringify(license))			
					this.editLicenseDialog = false
					await this.getCompanyLicenses()
					this.isLoadingDialog = false
				} catch (error) {
					this.isLoadingDialog = false
					this.alert = {isAlert: true, alertMessage: error.response.data.message}
				}
			}
		},
		openDeleteLicenseDialog(item) {              
			this.license = Object.assign({}, item)
			this.deleteLicenseDialog = true
		}, 
		closeDeleteLicenseDialog(){
			this.deleteLicenseDialog = false
			this.alert = {isAlert: false, alertMessage: ''} 
		},    
		async deleteLicense() {
			try {        
				this.isLoadingDialog = true   
				await axios.delete("api/v1/companies/"+ this.idCompany + "/licenses/" + this.license.id)
				this.deleteLicenseDialog = false
				await this.getCompanyLicenses()
				this.isLoadingDialog = false
			} catch(error) {   
				this.isLoadingDialog = false           
				this.alert = {isAlert: true, alertMessage: error.response.data.message}      
			}
		},
		isCloseLicensesCompanyDialog() {
			this.$emit('closeLicensesCompanyDialog')
		}       
	},
	computed: {
		...mapGetters([    
			'getRlDialogRules',
		]),
		licenseEndDate() {
			if (this.licenseStartDate && this.license?.duration) {
				let startDate = new Date(this.licenseStartDate)
				startDate.setMonth(startDate.getMonth() + this.license.duration)
				startDate.setDate(startDate.getDate() - 1)
				return startDate.toISOString().slice(0, 10)
			}
		}
	}
}
</script>